import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import MenuList from "~/components/Blocks/MenuList";

import PartyInputs from "~/components/Blocks/PartyInputs";
import { ApplicationForm_initialize, ApplicationFormSet, ApplicationFormSet_All, GetGroupDetail, CreateParty } from "../../stores/slices/ApplicationForm";
import { getLocalStorage } from "../../stores/Information";

import { GetMenuList } from "~slices/Menu";
import { ResetTvRounded } from "@mui/icons-material";

const ApplicationForm = () => {
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const menu_group_id = query.get("menu_group_id");
    const menu_id = query.get("menu_id");
    // 年月日からyy/mm/ddへの変換
    const regex = /年|月|日/g;
    const party_date = query.get("party_date") ? (query.get("party_date")).replaceAll(regex, "/").slice(0, -1) : "";
    const dispatch = useDispatch();

    const menu_state = useSelector((state) => state.Menu);
    const menu_list = menu_state.menu_list;
    // const party_state = useSelector((state) => state.Party);
    // const selected_group = menu_state.selected_group;

    // const category_data = [];
    // const drink_category_list = menu_state.drink_category_list;
    // const drink_list = menu_state.drink_list;
    // const [dc_id, set_dc_id] = React.useState("dc_00001");

    const [disabled, setDisabled] = useState(false);
    const informationState = useSelector((state) => state.Information);
    const ApplicationFormState = useSelector((state) => state.ApplicationForm);

    const [checkError, setCheckError] = useState(false);
    const [billError, setBillError] = useState(false);
    const [othersError, setOthersError] = useState(false);

    useEffect(() => {
        dispatch(ApplicationForm_initialize());

        //ログインしていないならログイン画面へ
        if(!getLocalStorage("organizer"))
        {
            const params = {
                party_date: query.get("party_date"),
                menu_group_id: menu_group_id,
                menu_id: menu_id ? menu_id : "",
                from: "ApplicationForm",
            };
    
            const urlSearchParam = new URLSearchParams(params).toString();
            history.push(`/Login?${urlSearchParam}`);
            return;
        }
        if (!menu_group_id) {
            history.push(`/`);
        }
        if (!party_date) {
            history.push(`/`);
        }

        dispatch(GetMenuList({ party_date: party_date, menu_group_id: menu_group_id })).then((data) => {
            // history.push(`/MemberManagement?${urlParam}`);
        });

        dispatch(GetGroupDetail({ menu_group_id: menu_group_id })).then((data) => {
            if(data.payload.menu_group)
            {
                const menu_group = data.payload.menu_group;
                dispatch(ApplicationFormSet(['menu_group_name', menu_group.menu_group_name]));
                dispatch(ApplicationFormSet(['price', menu_group.price]));
            }
        });
    }, []);

    //申込み内容を確認
    const HandleSubmit = (e) => {
        e.preventDefault();
        const elements = e.target?.elements;

        const party_start_time = e.target?.elements?.party_start_time?.value;

        const getValue = (name) => {
            let value = "";
            if (elements[name]?.value) {
                value = elements[name]?.value;
            }

            return value;
        };
        const getCheckedValue = (name) => {
            let value = "0";
            if (elements[name]?.checked) {
                value = "1";
            }

            return value;
        };

        const select_menu_id_list = menu_state.select_menu_id_list;
        //必須チェック
        if(select_menu_id_list.length === 0)
        {
            alert("料理を選択してください。");
            return;
        }
        
        const payment_bill_flag = getCheckedValue("payment_bill_flag");
        const payment_paypay_flag = getCheckedValue("payment_paypay_flag");
        const payment_others_flag = getCheckedValue("payment_others_flag");
        const payment_bill_company = payment_bill_flag === "1" ? getValue("payment_bill_company") : "";
        const payment_others_detail = payment_others_flag === "1" ? getValue("payment_others_detail") : "";
        //請求書,PayPay,その他どれか一つ以上必須
        if(payment_bill_flag === "0" && payment_paypay_flag === "0" && payment_others_flag === "0")
        {
            setCheckError(true);
            setBillError(false);
            setOthersError(false);
            return;
        }
        else
        {
            setCheckError(false);
        }
        //請求書チェック時
        if(payment_bill_flag === "1" && !payment_bill_company)
        {
            setBillError(true);
            return;
        }
        else
        {
            setBillError(false);
        }
        //その他チェック時
        if(payment_others_flag === "1" && !payment_others_detail)
        {
            setOthersError(true);
            return;
        }
        else
        {
            setOthersError(false);
        }

        //選択商品の数分回して商品名を取得
        let menu_name = [];
        select_menu_id_list.map((menu_id) => {
            let menu = menu_list.filter(function (item) {
                return item.menu_id === menu_id;
            });
            if(menu.length > 0) menu_name = [...menu_name, menu[0].menu_name];
        }
        );
        
        if (!party_date) {
            alert("懇親会の日付が設定されていません。");
        }
        const params = {
            party_date: party_date,
            organizer_id: informationState["organizer"]["organizer_id"],
            party_start_time: getValue("party_start_time"),
            party_name: getValue("party_name"),
            description: getValue("description"),
            coupon_code: getValue("coupon_code"),
            inquiry: getValue("inquiry"),
            planned_number: getValue("planned_number"),
            wfpf_number: getValue("wfpf_number"),
            select_menu_id_list: select_menu_id_list,
            payment_bill_flag: payment_bill_flag,
            payment_paypay_flag: payment_paypay_flag,
            payment_others_flag: payment_others_flag,
            payment_bill_company: payment_bill_company,
            payment_others_detail: payment_others_detail,
            menu_group_id: menu_group_id,
            menu_name: menu_name,
        };

        dispatch(ApplicationFormSet_All([params]));

        //確認画面を表示
        dispatch(ApplicationFormSet(['confirmation', true]));
        window.scroll({ top: 0, behavior: "smooth" });
    };

    const history = useHistory();

    //戻る
    const LinkClick = () => {
        history.push(`/`);
    };

    // const [SelectCheckList, setSelectCheckList] = React.useState(null);

    // const SelectCheck = (menu_id, bool) => {
    //     // console.log(menu_id);
    //     // console.log(bool);
    //     setSelectCheckList({
    //         menu_id: bool,
    //     });
    // };

    //修正する
    const EditClick = () => {
        setDisabled(false);
        //入力画面を表示
        dispatch(ApplicationFormSet(['confirmation', false]));
        window.scroll({ top: 0, behavior: "smooth" });
    };

    //申し込む
    const ConfirmationSubmit = (e) => {
        setDisabled(true);
        e.preventDefault();

        //登録処理
        dispatch(CreateParty(ApplicationFormState)).then((user_data) => {
            const result = user_data.payload.result;
            if(result === 'OK')
            {
                alert('申し込みが完了しました。');

                dispatch(ApplicationForm_initialize());
                const params = {
                    party_id: user_data.payload.party_id,
                };
                const urlSearchParam = new URLSearchParams(params).toString();
                //申込み詳細画面へ
                history.push(`/PartyDetail?${urlSearchParam}`);
            }
            else
            {
                //NGメッセージ表示
                alert(user_data.payload.message);
                setDisabled(false);
            }
        });
    }

    // const [price, set_price] = React.useState([1000, 10000]);
    // const column_list = [
    //     { name: "release_start_date", label: "公開開始日" },
    //     { name: "menu_name", label: "プラン名" },
    //     { name: "price", label: "価格" },
    //     { name: "present_drink_number", label: "プレゼントドリンク本数" },
    // ];
    // const [order, set_order] = React.useState("asc");
    // const [order_column, set_order_column] = React.useState("release_start_date");

    // const SortClick = (e) => {
    //     e.preventDefault();

    //     const params = {
    //         party_date: party_date,
    //         price: price,
    //         order: order,
    //         order_column: order_column,
    //     };

    //     dispatch(GetMenuList(params)).then((data) => {
    //         // history.push(`/MemberManagement?${urlParam}`);
    //     });
    // };


    return (
        <React.Fragment>
            <Grid style={{ display: ApplicationFormState.confirmation ? 'none' : '' }}>
                <Typography variant="h2" align="center">
                    お申込みフォーム
                </Typography>
                <Button size="small" variant="outlined" onClick={LinkClick}>
                    戻る
                </Button>
                <Container sx={{ mb: 5 }}>
                    {/* <Grid container direction="column" justifyContent="center" alignItems="flex-start"> */}
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        {/* <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            // justifyContent="flex-start"
                            alignItems="center"
                            // alignItems="flex-start"
                            sx={{ border: "solid 1px gray", p: 3, mb: 1 }}
                        >
                            絞り込み条件
                            <form onSubmit={SortClick} style={{ width: "inherit" }}>
                                <Grid container direction="column" justifyContent="center" alignItems="center">
                                    <Typography id="range-slider" gutterBottom>
                                        価格
                                    </Typography>
                                    <PliceSlider price={price} set_price={set_price} />
                                    <Grid container direction="row" justifyContent="center" alignItems="center">
                                        <TextField
                                            sx={{ mt: 2, mb: 1 }}
                                            //   value={age}
                                            required
                                            select
                                            label="値"
                                            SelectProps={{
                                                native: true,
                                            }}
                                            name="order_column"
                                            value={order_column}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => set_order_column(e.target.value)}
                                        >
                                            {column_list.map((column, index) => (
                                                <option value={column.name}>{column.label}</option>
                                            ))}
                                        </TextField>

                                        <TextField
                                            sx={{ mt: 2, mb: 1 }}
                                            //   value={age}
                                            required
                                            select
                                            label="並び順"
                                            SelectProps={{
                                                native: true,
                                            }}
                                            name="order"
                                            value={order}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => set_order(e.target.value)}
                                        >
                                            <option value={"asc"}>降順</option>
                                            <option value={"desc"}>昇順</option>
                                        </TextField>
                                    </Grid>
                                    <Grid container direction="row" justifyContent="flex-end" alignItems="flex-end">
                                        <Button variant="contained" type="submit">
                                            絞り込む
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid> */}

                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        お料理プラン
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 3, mb: 3, p: 2, backgroundColor: "#FAE9C8" }}>
                        <a style={{ fontWeight: 'bold' }}>
                            {ApplicationFormState.menu_group_name ? ApplicationFormState.menu_group_name : ""}
                        </a>
                        <br />
                        お一人様あたり税込{ApplicationFormState.price ? ApplicationFormState.price : ""}円（送料込）
                        <br /><br />
                        参加者様が選択可能なプランを以下で設定できます。
                        <br />
                        参加者様は、チェックが入っているプランの中からのみ、お料理をお選びいただけます。
                        <br />
                        たとえば、チェックを１つだけにすると、参加者様の選択肢は１つとなるため、全員で同じ料理を食べることができます。
                    </Typography>
                    <Grid
                        container
                        justifyContent="center"
                        sx={{
                            background: "#c7baaa3a",
                            minHeight: "10rem",
                            // mt: 2,
                            pt: 1,
                            pb: 1,
                        }}
                    >
                        <MenuList menu_list={menu_list} SelectCheck={true} check_menu_id={menu_id} />
                    </Grid>
                    {/*
                     <Typography variant="body2" sx={{ mt: 3, mb: 3 }}>
                         開催日の6日前までにお申し込みください。
                         <br />
                         参加者の住所登録の期限は5営業日前の16時までにお申し込みください。
                         <br />
                         それ以降の場合はご対応いたしかねます。何卒ご了承ください。
                     </Typography>
                */}
                    {/* <Box sx={{ bgcolor: "#fae9c8", p: 3, width: "100%", mt: 5, mb: 5 }}>
                        どのお食事をお選び頂いてもお一人様あたりの価格は¥4,500（税込¥4,950／送料込み）となります。
                    </Box> */}
                    {/* <Typography variant="h3">ドリンクプラン</Typography> */}
                    {/* <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        sx={{
                            background: "#ffaf54",
                            p: 2,
                            mt: 2,
                        }}
                    > */}
                    {/* {Object.keys(drink_category_list).map((this_dc_id, index) => (
                            <React.Fragment key={index}>
                                <Chip
                                    sx={{
                                        fontSize: "2rem",
                                        p: "0.5rem",
                                        m: "0.5rem",
                                        background: dc_id == this_dc_id ? "rgba(0, 0, 0, 0.12)" : "#fff",
                                    }}
                                    // color="warning"
                                    // variant="outlined"
                                    label={drink_category_list[this_dc_id].name}
                                    onClick={() => set_dc_id(this_dc_id)}
                                />
                            </React.Fragment>
                        ))} */}
                    {/* </Grid> */}
                    {/* 
                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3, mb: 2 }}>
                        選択したドリンクプラン
                    </Typography> */}
                    {/* <Typography variant="body1" sx={{ bgcolor: "#fae9c8", p: 3, mb: 1 }}>
                        <>
                            <span style={{ color: "warning.main", fontWeight: "bold" }}>
                                {drink_category_list[dc_id].name}プラン
                            </span>
                            <br />
                            お一人様あたり税込 {drink_category_list[dc_id].menu_price}円送料込み
                            <br />
                            下記のドリンク一覧から
                            <span style={{ color: "warning.main", fontWeight: "bold" }}>
                                {drink_category_list[dc_id].count}
                            </span>
                            本選択することができます。
                        </>
                    </Typography> */}
                    {/* <Grid container justifyContent="center" alignItems="center"> */}
                    {/* <DrinkList drink_list={drink_list[dc_id]} /> */}
                    {/* </Grid> */}
                    {/* <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                        金額確認
                    </Typography> */}
                    {/* <Grid container justifyContent="center" alignItems="center" sx={{ mt: 3, mb: 1 }}>
                        <Grid container justifyContent="center" alignItems="center">
                            <Typography variant="body1" sx={{ bgcolor: "#fae9c8", p: 3, mb: 1 }}>
                                <>
                                    <span style={{ color: "warning.main", fontWeight: "bold" }}>
                                        {selected_group?.menu_group_name}
                                    </span>
                                    <br />
                                    {selected_group?.description}
                                    <br />
                                    お一人様あたり税込 {selected_group?.price}円送料込み
                                </>
                            </Typography>
                        </Grid>
                        <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                            メニュー選択
                        </Typography>

                        <Typography variant="body2" sx={{ mt: 3, mb: 3 }}>
                            参加者様が下記の中からお食事をお選びいただけます。
                            <br />
                            全員同じメニューを選択する場合、一つだけにチェックをつけてください。
                        </Typography>
                        <form onSubmit={HandleSubmit} id="ApplicationForm" style={{ width: "inherit" }}>
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                //  alignItems="center"
                                alignItems="flex-start"
                            >
                                <PartyInputs
                                    // テスト用のため後削除
                                    party_data={{
                                        planned_number: "5",
                                        party_start_time: "20:00",
                                        party_name: "懇親会",
                                    }}
                                />
                            </Grid>
                        </Grid> */}
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ border: "solid 1px gray", p: 3, mb: 1 }}
                        >
                            <Typography variant="h3" sx={{ mb: 2 }}>
                                懇親会情報
                            </Typography>
                            <form onSubmit={HandleSubmit} id="ApplicationForm" style={{ width: "inherit" }}>
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    //  alignItems="center"
                                    alignItems="flex-start"
                                >
                                    <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                                        開催日
                                    </Typography>
                                    <Typography variant="h5" gutterBottom component="div" sx={{ mb: 3 }}>
                                        {party_date}
                                    </Typography>
                                    <PartyInputs billError={billError} othersError={othersError} checkError={checkError} organizerBusinessName={informationState.organizer.business_name} />
                                </Grid>
                            </form>
                            <Button
                                form="ApplicationForm"
                                variant="contained"
                                size="large"
                                color="primary"
                                type="submit"
                            >
                                申込み内容を確認
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
            <Grid style={{ display: ApplicationFormState.confirmation ? '' : 'none' }}>
                <Typography variant="h2" align="center">
                    お申込み内容確認
                </Typography>
                <Container sx={{ mb: 5 }}>
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ border: "solid 1px gray", p: 3, mb: 1 }}
                        >
                            <form onSubmit={ConfirmationSubmit} id="ApplicationFormConfirmation">
                                <Typography variant="h5" gutterBottom component="div">
                                    {"開催日"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.party_date}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"開始時間"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.party_start_time}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"開催名"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.party_name}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"懇親会の説明"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.description ? ApplicationFormState.description : "記入なし"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"ご選択の商品"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    コース：{ApplicationFormState.menu_group_name}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    参加者様が選択可能なプラン：
                                    {ApplicationFormState.menu_name.map((val) => (
                                        <>
                                            <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                                {val}
                                            </Typography>
                                        </>
                                    ))}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"参加予定人数"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.planned_number}人
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"WFPF承認番号"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.wfpf_number}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"お支払い方法"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    <Typography variant="h5" gutterBottom component="div" style={{ display: ApplicationFormState.payment_bill_flag === "1" ? '' : 'none' }}>
                                        {"請求書："}{ApplicationFormState.payment_bill_company}　{informationState.organizer.business_name}
                                    </Typography>
                                    <Typography variant="h5" gutterBottom component="div" style={{ display: ApplicationFormState.payment_paypay_flag === "1" ? '' : 'none' }}>
                                        {"PayPay"}
                                    </Typography>
                                    <Typography variant="h5" gutterBottom component="div" style={{ display: ApplicationFormState.payment_others_flag === "1" ? '' : 'none' }}>
                                        {"その他："}{ApplicationFormState.payment_others_detail}
                                    </Typography>
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"クーポンコード"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.coupon_code ? ApplicationFormState.coupon_code : "記入なし"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div">
                                    {"ご質問やお問い合わせ"}
                                </Typography>
                                <Typography variant="h5" gutterBottom component="div" sx={{ ml: 3 }}>
                                    {ApplicationFormState.inquiry ? ApplicationFormState.inquiry : "記入なし"}
                                </Typography>
                            </form>
                            <Grid style={{display:'inline-flex'}}>
                                <Grid style={{padding: "0rem 1.3rem"}}>
                                    <Button
                                        variant="contained"
                                        size="large"
                                        color="info"
                                        sx={{ width: "8rem" }}
                                        onClick={EditClick}
                                        //disabled={disabled}
                                    >
                                        修正する
                                    </Button>
                                </Grid>
                                <Grid style={{padding: "0rem 1.3rem"}}>
                                    <Button
                                        form="ApplicationFormConfirmation"
                                        variant="contained"
                                        size="large"
                                        color="primary"
                                        sx={{ width: "8rem" }}
                                        type="submit"
                                        disabled={disabled}
                                    >
                                        申し込む
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </React.Fragment>
    );
};
// const PliceSlider = (props) => {
//     const { price, set_price, ...other } = props;
//     const priceChange = (event, newValue) => {
//         set_price(newValue);
//     };
//     return (
//         <Box sx={{ width: "80%" }}>
//             <Slider
//                 getAriaLabel={() => "Temperature range"}
//                 //   value={value}
//                 min={1000}
//                 max={10000}
//                 step={100}
//                 name="price"
//                 value={price}
//                 onChange={priceChange}
//                 valueLabelDisplay="auto"
//                 marks={[
//                     {
//                         value: 1000,
//                         label: "1000円",
//                     },
//                     {
//                         value: 5000,
//                         label: "5000円",
//                     },
//                     {
//                         value: 10000,
//                         label: "1万円以上",
//                     },
//                 ]}
//                 //   getAriaValueText={valuetext}
//             />
//         </Box>
//     );
// };

export default ApplicationForm;
